export const UnbondingEndIcon = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.562 4.562h6.517v6.517m-6.517 0 6.517-6.517"
      stroke="#00c48c"
      strokeWidth="1.303"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
